import { useMutation } from '@tanstack/react-query';
import { logout as logoutAPI } from '../lib/auth';
import { removeToken } from '../lib/token';
import { useUserContext } from '../context/userContext';

export default function useLogout() {
	const { logout: logoutContext } = useUserContext();

	const cleanupAuthState = () => {
		removeToken();
		logoutContext();
	};

	return useMutation({
		mutationFn: async () => {
			await logoutAPI();
			cleanupAuthState();
		},
		onError: (error) => {
			// console.error('Logout error:', error);
			cleanupAuthState();
		},
	});
}
